module.exports = "<div *ngIf=\"saleUrl && !errorText\">\n\t<a target=\"_blank\" href=\"{{saleUrl}}\">\n\t\t{{saleUrl}}\n\t</a>\n</div>\n\n<div *ngIf=\"errorText\">\n\t<span>\n\t\tDer Link zum Online-Verkauf konnte nicht ermittelt werden. <br/>\n\t\t{{errorText}}\n\t</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/online-sale/online-sale.presentation.html
// module id = iiQa
// module chunks = 12